<div class="content" [ngClass]="{'left': isLeft}">
  <div class="row">
    <div class="col-12">
      <div class="header-wrapper">
        <div class="user">
          <custom-avatar [id]="data?.ID" [url]="data?.AVATAR_URL" 
            [name]="data.getName()"
            [color]="data.AVATAR_COLOR" size="48"></custom-avatar>
          <div class="user-name" *ngIf="data.FIRST_NAME && data.LAST_NAME">
            {{data?.FIRST_NAME+' '+data?.LAST_NAME}}</div>
          <div class="user-email" *ngIf="data.EMAIL">
            <a href="mailto:{{data.EMAIL}}">{{data.EMAIL}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
